import React from 'react';
import '../../assets/scss/projectTable.scss';
import { ReactComponent as CompletedIcon } from '../../assets/svg/checkmark-green.svg';
import { ReactComponent as TbdIcon } from '../../assets/svg/tbd-icon.svg';
import moment from 'moment';
import Modal from '../components/modals/index';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip';
import ShootFlagDropdown from '../components/mainProject/shootFlagDropdown';
import { withRouter } from '../../services/withRoute';
import ImageSlider from './modals/global/imageSlider';
import CopyShootCrew from './modals/shoots/copyCrew';

class ShootsListTableRow extends React.Component {
	constructor() {
		super();
		this.state = {
			search: false,
			showDetailProjectModal: false,
			showLinkedEvents: false,
			flagList: [
				{ value: 'red', label: 'Red' },
				{ value: 'green', label: 'Green' },
				{ value: 'yellow', label: 'Yellow' },
			],
			xPos: '0px',
			yPos: '0px',
			showMenu: false,
			showImageSliderModal: false,
			showCopyCrewModal: false,
			copyDetails: {},
			showRemoveCrewMenu: false,
			removeCrewIndex: -1,
			removeCrewRolesIndex: -1,
			removeCrew: {},
			yCrewPos: '0px',
			xCrewPos: '0px',
		};
		this.ref = React.createRef();
	}
	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
		let el = document.getElementById('scrollableDiv-shoots-vendors');
		el.addEventListener('scroll', this.handleOnScroll);
		document.addEventListener('scroll', this.handleOnScroll);
	};

	handleOnScroll = (e) => {
		if (this.state.showMenu === true) {
			this.setState({
				showMenu: false,
			});
		}
		if (this.state.showRemoveCrewMenu === true) {
			this.setState({
				showRemoveCrewMenu: false,
			});
		}
	};

	componentWillUnmount() {
		let el = document.getElementById('scrollableDiv-shoots-vendors');
		el.removeEventListener('scroll', this.handleOnScroll);
		document.removeEventListener('scroll', this.handleOnScroll);
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	handleClickOutside = (event) => {
		if (this.ref.current && !this.ref.current.contains(event.target)) {
			this.setState({
				showMenu: false,
			});
		}
		if (this.state.showRemoveCrewMenu === true) {
			setTimeout(() => {
				this.setState({
					showRemoveCrewMenu: false,
				});
			}, 200);
		}
	};

	showImageSliderModal = () => {
		this.setState({
			showImageSliderModal: !this.state.showImageSliderModal,
		});
	};
	handleContextMenu = (e) => {
		if (e) {
			e.preventDefault();
			this.setState({
				xPos: `${e.clientX}px`,
				yPos: `${
					document.body.clientHeight - e.clientY <
					(_.has(this.props, 'isProjectShootsList') && this.props.isProjectShootsList
						? 188
						: 328)
						? e.clientY -
						  (_.has(this.props, 'isProjectShootsList') &&
						  this.props.isProjectShootsList
								? 138
								: 328)
						: e.clientY
				}px`,
				showMenu: true,
			});
		}
	};
	handleSingleCrewContextMenu = (e, crew, index) => {
		if (e) {
			e.stopPropagation();
			e.preventDefault();

			let tempInx = -1;
			let removeCrewIndex = -1;
			let removeCrewRolesIndex = -1;

			_.forEach(this.props.data.crewNew, (cr, inx) => {
				_.forEach(cr.roles, (r, i) => {
					if (r.role === crew.role && r.subRole === crew.subRole && tempInx < index) {
						tempInx += 1;
						removeCrewIndex = inx;
						removeCrewRolesIndex = i;
					}
				});
			});

			this.setState({
				removeCrew: crew,
				removeCrewIndex: removeCrewIndex,
				removeCrewRolesIndex: removeCrewRolesIndex,
				xCrewPos: `${e.clientX}px`,
				yCrewPos: `${e.clientY}px`,
				showRemoveCrewMenu: true,
			});
		}
	};
	handleClick = (e) => {
		if (this.state.showMenu) this.setState({ showMenu: false });
	};
	formatCurrency = (type, number) => {
		switch (type) {
			case 'inr':
				return new Intl.NumberFormat('en-IN', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			case 'usd':
				return new Intl.NumberFormat('en-US', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			default:
				return number;
		}
	};
	toggleShowLinkedEvents = (e) => {
		this.setState({
			showLinkedEvents: !this.state.showLinkedEvents,
		});
	};
	renderToolTip = (id, content, role) => {
		return (
			<ReactTooltip
				id={id}
				place="right"
				effect="solid"
				backgroundColor="transparent"
				//delayHide={1000}
				isCapture
				clickable
				globalEventOff="click"
			>
				<div className="project-tool-tip-container">
					<div className="content">{content}</div>
				</div>
			</ReactTooltip>
		);
	};
	handleCityClick = (e) => {
		if (this.props.data.city !== null || this.props.data.city !== '') {
			e.stopPropagation();
			this.props.onCityClick(e, this.props.data.city);
		}
	};
	handleProjectClick = (e) => {
		e.stopPropagation();

		// if (e.metaKey) {
		// 	let url =
		// 		window.location.origin.split('//')[1].split('.')[0] === 'dev-vendors'
		// 			? 'https://dev-vendors.huemn.com/' +
		// 			  `${this.props.params.vendorID}/shoots/${
		// 					_.filter(this.props.associatedTenants, {
		// 						_id: this.props.data.tenantId,
		// 					})[0]['workspaceId']
		// 			  }/${this.props.data.projectId}`
		// 			: window.location.origin.split('//')[1].split('.')[0] === 'vendors'
		// 			? 'https://vendors.huemn.com/' +
		// 			  `${this.props.params.vendorID}/shoots/${
		// 					_.filter(this.props.associatedTenants, {
		// 						_id: this.props.data.tenantId,
		// 					})[0]['workspaceId']
		// 			  }/${this.props.data.projectId}`
		// 			: 'http://' +
		// 			  window.location.hostname +
		// 			  ':3000/' +
		// 			  `${this.props.params.vendorID}/shoots/${
		// 					_.filter(this.props.associatedTenants, {
		// 						_id: this.props.data.tenantId,
		// 					})[0]['workspaceId']
		// 			  }/${this.props.data.projectId}`;
		// 	window.open(url, '_blank');
		// } else {
		// 	this.props.onProjectClick(e, this.props.data.projectTitle);
		// }
		// Same-origin link — reuse whatever host we're on (vendors.huemn.com,
		// dev-vendors.huemn.com, the vendors.ve.co white-label, or localhost:3000).
		// ponytail: don't rebuild an absolute cross-origin URL; the shoot route is served by this app.
		let url = `${window.location.origin}/${this.props.params.vendorID}/shoots/${
			_.filter(this.props.associatedTenants, {
				_id: this.props.data.tenantId,
			})[0]['workspaceId']
		}/${this.props.data.projectId}`;
		window.open(url, '_blank');
	};

	copyCrewForEvent = () => {
		let photoText =
			_.size(
				_.filter(this.props.data.crewDetails, {
					role: 'photographer',
				}),
			) > 0
				? '*Photo Team*\n' +
				  _.map(
						_.filter(this.props.data.crewDetails, {
							role: 'photographer',
						}),
						(crew, key) =>
							crew.name !== ''
								? `• ${crew.displayName === '' ? crew.name : crew.displayName}${
										crew.isManager ? '*' : ''
								  } (${
										_.has(crew, 'subRole')
											? crew.subRole.charAt(0).toUpperCase()
											: ''
								  })\n`
								: '',
				  )
						.toString()
						.replaceAll(',', '')
				: '';

		let videoText =
			_.size(
				_.filter(this.props.data.crewDetails, {
					role: 'cinematographer',
				}),
			) > 0
				? '*Video Team* \n' +
				  _.map(
						_.filter(this.props.data.crewDetails, {
							role: 'cinematographer',
						}),
						(crew, key) =>
							crew.name !== ''
								? `• ${crew.displayName === '' ? crew.name : crew.displayName}${
										crew.isManager ? '*' : ''
								  } (${
										_.has(crew, 'subRole')
											? crew.subRole.charAt(0).toUpperCase()
											: ''
								  })\n`
								: '',
				  )
						.toString()
						.replaceAll(',', '')
				: '';

		let message = `*${moment(this.props.data.date, 'YYYYMMDD').format('DD MMM YYYY')}, ${
			this.props.data.reportingTime ? this.props.data.reportingTime : ''
		}*\n*${this.props.data.projectTitle} - ${
			this.props.data.name
		}* \n\n${photoText} \n${videoText}\n📍 *${this.props.data.city}*\n${
			this.props.data.venue === null ? '' : this.props.data.venue + ','
		} `;

		navigator.clipboard.writeText(message);
	};

	notifyUsers = () => {
		if (
			this.props.data.date === null ||
			this.props.data.date === '' ||
			this.props.data.reportingTime === null ||
			this.props.data.reportingTime === '' ||
			this.props.data.city === null ||
			this.props.data.city === '' ||
			_.size(_.filter(this.props.data.crewNew, (crew) => crew.userId !== null)) === 0
		) {
			alert('Date, Reporting Time, City, Crew are Mandatory');
		} else
			this.props.notifyTeamMembers(
				this.props.data.tenantId,
				this.props.data.projectId,
				this.props.data.id,
			);
	};

	showCopyCrewModal = () => {
		let eventDetails = this.props.data;

		let crewDetails = [];

		if (this.state.showCopyCrewModal === false) {
			_.forEach(this.props.data.crewDetails, (crew, inx) => {
				if (crew.id !== null) {
					crewDetails.push(crew);
				}
			});

			eventDetails.crewDetails = crewDetails;
		}

		this.setState({
			showCopyCrewModal: !this.state.showCopyCrewModal,
			copyDetails: {
				eventDetails,
			},
		});
	};

	render() {
		return (
			<>
				<tr
					id={this.props.data.id}
					height={40}
					//onClick={this.props.handleShootClick}
					className={this.state.showLinkedEvents ? 'no-border-row' : ''}
					onClick={(e) => this.handleClick(e)}
					onContextMenu={(e) => this.handleContextMenu(e)}
					ref={this.ref}
					style={_.has(this.props, 'style') ? this.props.style : {}}
				>
					{/* <td className="all-other-column-fixed">
						<ShootFlagDropdown
							flag={this.props.data.flagLabel}
							onFlagSelected={(flag) =>
								this.props.onFlagSelected(
									flag,
									this.props.data.tenantId,
									this.props.data.projectId,
									this.props.data.id,
								)
							}
							flagList={this.state.flagList}
						/>
					</td> */}
					<td className="all-other-column-fixed" onClick={this.props.handleShootClick}>
						<div className="event-city-date-container" style={{ alignItems: 'center' }}>
							<div className="top-text-container">
								{this.props.data.reportingTime ? (
									this.props.data.reportingTime
								) : (
									<span
										style={{
											color: '#B0B0B0',
										}}
									>
										<TbdIcon />
										Time
									</span>
								)}

								{/* {this.props.data.outStation ? (
									<span className="outStations">OS</span>
								) : (
									''
								)} */}
							</div>{' '}
						</div>
					</td>
					<td className="all-other-column-fixed" onClick={this.props.handleShootClick}>
						<div className="event-city-date-container">
							{this.props.data.date ? (
								<>
									<div
										className="top-text-container"
										onClick={(e) =>
											_.has(this.props, 'isProjectShootsList')
												? ''
												: this.handleCityClick(e)
										}
									>
										{/* {this.props.data.reportingTime
											? this.props.data.reportingTime
											: 'TBD'}

										{this.props.data.outStation ? (
											<span className="outStations">OS</span>
										) : (
											''
										)} 
										*/}
										{this.props.data.city ? (
											this.props.data.city
										) : (
											<span
												style={{
													color: '#B0B0B0',
												}}
											>
												<TbdIcon />
												City
											</span>
										)}
									</div>{' '}
								</>
							) : (
								<div
									className="top-text-container"
									style={{
										color: '#B0B0B0',
									}}
								>
									<TbdIcon />
									City
								</div>
							)}
							<div
								className="bottom-text-container shoot-list-city"
								// onClick={(e) =>
								// 	_.has(this.props, 'isProjectShootsList')
								// 		? ''
								// 		: this.handleCityClick(e)
								// }
							>
								{this.props.data.venue ? (
									this.props.data.venue
								) : (
									<span
										style={{
											color: '#B0B0B0',
										}}
									>
										<TbdIcon />
										Venue
									</span>
								)}
							</div>
						</div>
					</td>
					{_.has(this.props, 'associatedTenants') ? (
						<td
							className="all-other-column-fixed"
							onClick={this.props.handleShootClick}
						>
							<div className="eq-mc-outer-container">
								{/* {this.props.data.memoryCards === null ||
							_.size(this.props.data.memoryCards) === 0 ? null : (
								<span className="eq-mc-container">
									<span style={{ marginLeft: '5px' }}>
										{`${_.size(
											_.filter(this.props.data.memoryCards, {
												isReceived: true,
											}),
										)}
									/ ${_.size(this.props.data.memoryCards)}`}
									</span>
								</span>
							)} */}
								<span className="eq-mc-container">
									<span style={{ marginLeft: '5px' }}>
										{_.filter(this.props.associatedTenants, {
											_id: this.props.data.tenantId,
										})[0]
											? `${
													_.filter(this.props.associatedTenants, {
														_id: this.props.data.tenantId,
													})[0]['workspaceKey']
											  }`
											: ''}{' '}
										- {this.props.data.slNo}
									</span>
								</span>
								{this.props.data.outStation ? (
									<span
										style={{
											background: '#0f72a3',
											borderRadius: '100px',
											padding: '1px 6px',
											fontFamily: 'Inter',
											fontStyle: 'normal',
											fontWeight: '500',
											fontSize: '11px',
											lineHeight: '16px',
											textAlign: 'center',
											letterSpacing: '-0.3px',
											color: '#ffffff',
										}}
									>
										OS
									</span>
								) : (
									''
								)}
							</div>
						</td>
					) : (
						''
					)}
					<td className="wedding-details-column" onClick={this.props.handleShootClick}>
						<div className="event-city-date-container">
							<div
								className="top-text-container shoot-list-city"
								onClick={(e) =>
									_.has(this.props, 'isProjectShootsList')
										? ''
										: this.handleProjectClick(e)
								}
							>
								{_.has(this.props, 'associatedTenants')
									? ''
									: _.filter(this.props.associatedTenants, {
											_id: this.props.data.tenantId,
									  })[0]
									? `(${
											_.filter(this.props.associatedTenants, {
												_id: this.props.data.tenantId,
											})[0]['workspaceKey']
									  })`
									: ''}{' '}
								{this.props.data.projectTitle}
							</div>
							<div className="top-text-container" style={{ color: '#B0B0B0' }}>
								<span
									style={{
										color:
											_.has(this.props, 'isProjectShootsList') &&
											this.props.isProjectShootsList === true
												? '#fff'
												: '#B0B0B0',
									}}
								>
									{this.props.data.name}{' '}
								</span>
								{_.size(this.props.data.childEvents) > 0 ? (
									<span
										className="event-grouping-count"
										onClick={(e) => [
											this.toggleShowLinkedEvents(e),
											e.stopPropagation(),
										]}
									>
										+ {_.size(this.props.data.childEvents)}
									</span>
								) : (
									''
								)}
							</div>
							{/* <div className="bottom-text-container">
								{_.filter(this.props.associatedTenants, {
									_id: this.props.data.tenantId,
								})[0]
									? _.filter(this.props.associatedTenants, {
											_id: this.props.data.tenantId,
									  })[0]['workspaceKey']
									: ''}
								{this.props.data.projectSlNo
									? `/ PJ-${this.props.data.projectSlNo}`
									: ''}
								{this.props.data.slNo ? `/ ST-${this.props.data.slNo}` : ''}
							</div> */}
						</div>
					</td>
					{/* Candid Photography */}
					<td
						className="all-other-column-fixed shooter-column"
						onClick={this.props.handleShootClick}
					>
						<div className="project-general-box">
							<span className="crew-outer-container">
								{_.size(
									_.filter(this.props.data.crewDetails, {
										role: 'photographer',
										subRole: 'candid',
									}),
								) > 0 ? (
									_.filter(this.props.data.crewDetails, {
										role: 'photographer',
										subRole: 'candid',
									}).map((e, i) => {
										return (
											<b
												className={
													'starFilled' +
													(e.dateOverlap ? ' date-overlap' : '') +
													(e.dateTimeOverlap ? ' date-time-overlap' : '')
												}
												key={i}
												style={{
													background:
														e.dateTimeOverlap === true
															? '#CA5A4F'
															: e.dateOverlap === true
															? '#9b6a2d'
															: 'none',
													borderRadius: 0,
													border: 'none',
													height: 20,
													padding: e.dateOverlap === true ? '0 10px' : 0,

													// borderRadius:
													// 	e.dateOverlap === true ? '10px' : 0,
												}}
												onContextMenu={(obj) =>
													this.handleSingleCrewContextMenu(obj, e, i)
												}
											>
												{e.displayName === 'unassigned' ||
												e.name === 'unassigned' ? (
													<span style={{ color: '#FDB946' }}>
														Unassigned
													</span>
												) : (
													<span
														className="crew-name-text"
														style={{
															color: '#e4e5e6',
														}}
													>
														{_.has(e, 'displayName') &&
														e.displayName !== ''
															? e.displayName
															: e.name}
													</span>
												)}
											</b>
										);
									})
								) : (
									<span style={{ color: '#FDB946' }}></span>
								)}
							</span>
						</div>
					</td>
					{/* Traditional Photography */}
					<td
						className="all-other-column-fixed shooter-column"
						onClick={this.props.handleShootClick}
					>
						<div className="project-general-box">
							<span className="crew-outer-container">
								{_.size(
									_.filter(this.props.data.crewDetails, {
										role: 'photographer',
										subRole: 'traditional',
									}),
								) > 0 ? (
									_.filter(this.props.data.crewDetails, {
										role: 'photographer',
										subRole: 'traditional',
									}).map((e, i) => (
										<b
											className={
												'starFilled' +
												(e.dateOverlap ? ' date-overlap' : '') +
												(e.dateTimeOverlap ? ' date-time-overlap' : '')
											}
											key={i}
											style={{
												background:
													e.dateTimeOverlap === true
														? '#CA5A4F'
														: e.dateOverlap === true
														? '#9b6a2d'
														: 'none',
												borderRadius: 0,
												border: 'none',
												height: 20,
												padding: e.dateOverlap === true ? '0 10px' : 0,

												// borderRadius:
												// 	e.dateOverlap === true ? '10px' : 0,
											}}
											onContextMenu={(obj) =>
												this.handleSingleCrewContextMenu(obj, e, i)
											}
										>
											{e.displayName === 'unassigned' ||
											e.name === 'unassigned' ? (
												<span style={{ color: '#FDB946' }}>Unassigned</span>
											) : (
												<span
													className="crew-name-text"
													style={{ color: '#e4e5e6' }}
												>
													{_.has(e, 'displayName') && e.displayName !== ''
														? e.displayName
														: e.name}
												</span>
											)}
										</b>
									))
								) : (
									<span style={{ color: '#FDB946' }}></span>
								)}
							</span>
						</div>
					</td>
					{/* Candid Videography */}
					<td
						className="all-other-column-fixed shooter-column"
						onClick={this.props.handleShootClick}
					>
						<div className="project-general-box">
							<span className="crew-outer-container">
								{_.size(
									_.filter(this.props.data.crewDetails, {
										role: 'cinematographer',
										subRole: 'candid',
									}),
								) > 0 ? (
									_.filter(this.props.data.crewDetails, {
										role: 'cinematographer',
										subRole: 'candid',
									}).map((e, i) => (
										<b
											className={
												'starFilled' +
												(e.dateOverlap ? ' date-overlap' : '') +
												(e.dateTimeOverlap ? ' date-time-overlap' : '')
											}
											key={i}
											style={{
												background:
													e.dateTimeOverlap === true
														? '#CA5A4F'
														: e.dateOverlap === true
														? '#9b6a2d'
														: 'none',
												borderRadius: 0,
												border: 'none',
												height: 20,
												padding: e.dateOverlap === true ? '0 10px' : 0,

												// borderRadius:
												// 	e.dateOverlap === true ? '10px' : 0,
											}}
											onContextMenu={(obj) =>
												this.handleSingleCrewContextMenu(obj, e, i)
											}
										>
											{e.displayName === 'unassigned' ||
											e.name === 'unassigned' ? (
												<span style={{ color: '#FDB946' }}>Unassigned</span>
											) : (
												<span
													className="crew-name-text"
													style={{ color: '#e4e5e6' }}
												>
													{_.has(e, 'displayName') && e.displayName !== ''
														? e.displayName
														: e.name}
												</span>
											)}
										</b>
									))
								) : (
									<span style={{ color: '#FDB946' }}></span>
								)}
							</span>
						</div>
					</td>
					{/* Traditional Videography */}
					<td
						className="all-other-column-fixed shooter-column"
						onClick={this.props.handleShootClick}
					>
						<div className="project-general-box">
							<span className="crew-outer-container">
								{_.size(
									_.filter(this.props.data.crewDetails, {
										role: 'cinematographer',
										subRole: 'traditional',
									}),
								) > 0 ? (
									_.filter(this.props.data.crewDetails, {
										role: 'cinematographer',
										subRole: 'traditional',
									}).map((e, i) => (
										<b
											className={
												'starFilled' +
												(e.dateOverlap ? ' date-overlap' : '') +
												(e.dateTimeOverlap ? ' date-time-overlap' : '')
											}
											key={i}
											style={{
												background:
													e.dateTimeOverlap === true
														? '#CA5A4F'
														: e.dateOverlap === true
														? '#9b6a2d'
														: 'none',
												borderRadius: 0,
												border: 'none',
												height: 20,
												padding: e.dateOverlap === true ? '0 10px' : 0,

												// borderRadius:
												// 	e.dateOverlap === true ? '10px' : 0,
											}}
											onContextMenu={(obj) =>
												this.handleSingleCrewContextMenu(obj, e, i)
											}
										>
											{e.displayName === 'unassigned' ||
											e.name === 'unassigned' ? (
												<span style={{ color: '#FDB946' }}>Unassigned</span>
											) : (
												<span
													className="crew-name-text"
													style={{ color: '#e4e5e6' }}
												>
													{_.has(e, 'displayName') && e.displayName !== ''
														? e.displayName
														: e.name}
												</span>
											)}
										</b>
									))
								) : (
									<span style={{ color: '#FDB946' }}></span>
								)}
							</span>
						</div>
					</td>
					<td className="all-other-column-fixed" onClick={this.props.handleShootClick}>
						<div className="eq-mc-outer-container">
							{(this.props.data.equipments === null ||
								_.size(this.props.data.equipments) === 0) &&
							(this.props.data.unregisteredEqs === null ||
								_.size(this.props.data.unregisteredEqs) === 0) ? null : (
								<span className="eq-mc-container">
									<span style={{ marginLeft: '5px' }}>
										{`${
											_.has(this.props.data, 'unregisteredEqs')
												? _.sum(
														_.map(
															this.props.data.unregisteredEqs,
															(equipment) =>
																equipment.receivedQuantity,
														),
												  ) +
												  _.size(
														_.filter(this.props.data.equipments, {
															isReceived: true,
														}),
												  )
												: _.size(
														_.filter(this.props.data.equipments, {
															isReceived: true,
														}),
												  )
										}
									/ ${
										_.has(this.props.data, 'unregisteredEqs')
											? _.sum(
													_.map(
														this.props.data.unregisteredEqs,
														(equipment) => equipment.quantity,
													),
											  ) + _.size(this.props.data.equipments)
											: _.size(this.props.data.equipments)
									} `}
									</span>
								</span>
							)}
						</div>
					</td>
					<td className="all-other-column-fixed" onClick={this.props.handleShootClick}>
						<div className="eq-mc-outer-container">
							{this.props.data.memoryCards === null ||
							_.size(this.props.data.memoryCards) === 0 ? null : (
								<span className="eq-mc-container">
									<span style={{ marginLeft: '5px' }}>
										{`${_.size(
											_.filter(this.props.data.memoryCards, {
												isReceived: true,
											}),
										)}
									/ ${_.size(this.props.data.memoryCards)}`}
									</span>
								</span>
							)}
						</div>
					</td>
					<td className="wedding-details-column" onClick={this.props.handleShootClick}>
						<div className="additional-services-shoot-container">
							{_.map(this.props.data.additionalServices, (service) => {
								return (
									<span className="eq-mc-container text-12px">
										{service.type
											? service.type.charAt(0).toUpperCase() +
											  service.type.replace(/([A-Z])/g, ' $1').slice(1)
											: null}
									</span>
								);
							})}
						</div>
					</td>
					<td
						className="all-other-column-fixed"
						onClick={() =>
							this.props.data.feedBack !== null &&
							_.size(this.props.data.feedBack) > 0 &&
							this.showImageSliderModal()
						}
					>
						{this.props.data.feedBack !== null &&
						_.size(this.props.data.feedBack) > 0 ? (
							<div className="shoot-checkbox-container">
								{' '}
								<CompletedIcon />
							</div>
						) : null}
					</td>
					{_.has(this.props, 'columns') &&
					_.size(_.filter(this.props.columns, { title: 'HEADS' })) > 0 ? (
						<td
							className="all-other-column-fixed"
							onClick={this.props.handleShootClick}
						>
							{_.size(this.props.photoHeads) > 0
								? _.map(this.props.photoHeads, (user) => {
										return (
											<span className="crew-outer-container">(P) {user}</span>
										);
								  })
								: ''}
							{_.size(this.props.videoHeads) > 0
								? _.map(this.props.videoHeads, (user) => {
										return (
											<span className="crew-outer-container">(V) {user}</span>
										);
								  })
								: ''}
						</td>
					) : (
						''
					)}

					{this.state.showRemoveCrewMenu ? (
						<div
							className="shoot-right-click-menu"
							style={{
								top: this.state.yCrewPos,
								left: this.state.xCrewPos,
								position: 'fixed',
							}}
						>
							<span
								onClick={(e) =>
									this.props.handleSingleCrewRemove(
										this.props.data,
										this.state.removeCrewIndex,
										this.state.removeCrewRolesIndex,
									)
								}
							>
								Remove
							</span>
						</div>
					) : null}

					{this.state.showMenu ? (
						_.has(this.props, 'isProjectShootsList') &&
						this.props.isProjectShootsList ? (
							<div
								className="shoot-right-click-menu"
								style={{
									top: this.state.yPos,
									left: this.state.xPos,
									position: 'fixed',
								}}
							>
								{/* <span onClick={(e) => this.props.handleShootClick(e)}>Edit Shoot</span> */}
								<span onClick={(e) => this.props.handleCrewClick('details')}>
									Edit Details
								</span>
								<span onClick={(e) => this.props.handleCrewClick('crew')}>
									Edit Crew
								</span>
								<span onClick={(e) => this.copyCrewForEvent()}>Copy Schedule</span>
								<span
									onClick={(e) =>
										this.props.isCrewCopied
											? this.props.pasteCrew(
													this.props.data.tenantId,
													this.props.data.projectId,
													this.props.data.id,
													this.props.data.crewDetails,
											  )
											: this.showCopyCrewModal()
									}
								>
									{this.props.isCrewCopied ? 'Paste' : 'Copy'} Crew
								</span>
							</div>
						) : (
							<div
								className="shoot-right-click-menu"
								style={{
									top: this.state.yPos,
									left: this.state.xPos,
									position: 'fixed',
								}}
							>
								{/* <span onClick={(e) => this.props.handleShootClick(e)}>Edit Shoot</span> */}
								<span onClick={(e) => this.props.handleShootClick(e, true)}>
									Open in New Tab
								</span>
								<span onClick={(e) => this.props.handleCrewClick('details')}>
									Edit Details
								</span>
								<span onClick={(e) => this.props.handleCrewClick('crew')}>
									Edit Crew
								</span>
								<span onClick={(e) => this.props.handleEquipmentClick('assign')}>
									Assign Equipment
								</span>
								<span onClick={(e) => this.props.handleEquipmentClick('receive')}>
									Receive Equipment
								</span>
								<span onClick={(e) => this.props.handleMCClick('assign')}>
									Assign Memory Cards
								</span>
								<span onClick={(e) => this.props.handleMCClick('receive')}>
									Receive Memory Cards
								</span>
								<span onClick={(e) => this.copyCrewForEvent()}>Copy Schedule</span>
								<span
									onClick={(e) =>
										this.props.isCrewCopied
											? this.props.pasteCrew(
													this.props.data.tenantId,
													this.props.data.projectId,
													this.props.data.id,
													this.props.data.crewDetails,
											  )
											: this.showCopyCrewModal()
									}
								>
									{this.props.isCrewCopied ? 'Paste' : 'Copy'} Crew
								</span>
								<span onClick={(e) => this.notifyUsers()}>Notify Team</span>
							</div>
						)
					) : (
						''
					)}
				</tr>
				{this.state.showLinkedEvents ? (
					<>
						{_.size(this.props.data.childEvents) > 0 ? (
							<tr className={'event-grouping-row-plus'}>
								<td className="all-other-column-fixed"></td>
								<td className="all-other-column-fixed"></td>
								<td className="wedding-details-column" style={{ color: '#707070' }}>
									{' '}
									+{' '}
								</td>
								<td className="all-other-column-fixed"></td>
								<td className="all-other-column-fixed"></td>
								<td className="all-other-column-fixed"></td>
								<td className="all-other-column-fixed"></td>
								<td className="all-other-column-fixed"></td>
								<td className="wedding-details-column"></td>
							</tr>
						) : (
							''
						)}
						{_.size(this.props.data.childEvents) > 0
							? _.map(this.props.data.childEvents, (child, key) => {
									return (
										<>
											<tr
												onClick={(e) =>
													this.props.handleShootClick(e, child._id)
												}
												className={` ${
													_.size(this.props.data.childEvents) == key + 1
														? 'event-grouping-row-plus-with-border'
														: 'event-grouping-row'
												}`}
											>
												<td className="all-other-column-fixed"></td>
												<td className="all-other-column-fixed"></td>
												<td className="wedding-details-column">
													<div className="project-general-box">
														<span className="black-amount-number-text">
															{child.name}
														</span>
													</div>
												</td>

												<td className="all-other-column-fixed"></td>
												<td className="all-other-column-fixed"></td>
												<td className="all-other-column-fixed"></td>
												<td className="all-other-column-fixed"></td>
												<td className="all-other-column-fixed"></td>
												<td className="wedding-details-column"></td>
											</tr>
											{_.size(this.props.data.childEvents) !== key + 1 ? (
												<tr className={'event-grouping-row-plus'}>
													<td className="all-other-column-fixed"></td>
													<td className="all-other-column-fixed"></td>
													<td
														className="wedding-details-column"
														style={{
															color: '#707070',
														}}
													>
														{' '}
														+{' '}
													</td>
													<td className="all-other-column-fixed"></td>
													<td className="all-other-column-fixed"></td>
													<td className="all-other-column-fixed"></td>
													<td className="all-other-column-fixed"></td>
													<td className="all-other-column-fixed"></td>
													<td className="wedding-details-column"></td>
												</tr>
											) : (
												''
											)}
										</>
									);
							  })
							: ''}
					</>
				) : (
					''
				)}
				{this.state.showImageSliderModal === true ? (
					<ImageSlider
						show={this.state.showImageSliderModal}
						close={() => this.showImageSliderModal()}
						shootInfo={this.props.data}
						slidesData={
							this.props.data.feedBack && _.size(this.props.data.feedBack) > 0
								? this.props.data.feedBack[0].files
								: []
						}
						associatedTenants={this.props.associatedTenants}
						crewDetails={this.props.data.crewDetails}
					/>
				) : null}
				{this.state.showCopyCrewModal ? (
					<CopyShootCrew
						close={() => this.setState({ showCopyCrewModal: false })}
						handleClose={() => this.setState({ showCopyCrewModal: false })}
						show={this.state.showCopyCrewModal}
						copyDetails={this.state.copyDetails}
						copyCrew={this.props.copyCrew}
					/>
				) : null}
			</>
		);
	}
}

export default withRouter(ShootsListTableRow);
